module.exports = __webpack_public_path__ + "media/images/icon_twitter-50c3f7ba1b33275460347aec410cedac.svg";